import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  SupportTicketAddMessageDto,
  SupportTicketAdminListResponse,
  SupportTicketCreateDto,
  SupportTicketMessageModel,
  SupportTicketMessagesResponse,
  SupportTicketModel,
  SupportTicketReporterLocale,
  SupportTicketSource,
  SupportTicketStatus,
} from '@nx-c4g/c4g-models';
import { firstValueFrom } from 'rxjs';
import { UIENVSETTINGS } from '../environment';

@Injectable()
export class SupportTicketService {
  constructor(
    private readonly http: HttpClient,
    @Inject(UIENVSETTINGS) private readonly env: { api: string }
  ) {}

  submit(body: SupportTicketCreateDto): Promise<SupportTicketModel> {
    const url = `${this.env.api}support-tickets`;
    return firstValueFrom(this.http.post<SupportTicketModel>(url, body));
  }

  listMine(q: {
    source?: SupportTicketSource;
    page?: number;
    limit?: number;
  }): Promise<SupportTicketAdminListResponse> {
    let params = new HttpParams();
    if (q.source) {
      params = params.set('source', q.source);
    }
    if (q.page != null) {
      params = params.set('page', String(q.page));
    }
    if (q.limit != null) {
      params = params.set('limit', String(q.limit));
    }
    const url = `${this.env.api}support-tickets/me`;
    return firstValueFrom(
      this.http.get<SupportTicketAdminListResponse>(url, { params })
    );
  }

  listMessages(ticketId: string): Promise<SupportTicketMessagesResponse> {
    const url = `${this.env.api}support-tickets/${ticketId}/messages`;
    return firstValueFrom(this.http.get<SupportTicketMessagesResponse>(url));
  }

  addMessage(
    ticketId: string,
    body: SupportTicketAddMessageDto
  ): Promise<SupportTicketMessageModel> {
    const url = `${this.env.api}support-tickets/${ticketId}/messages`;
    return firstValueFrom(
      this.http.post<SupportTicketMessageModel>(url, body)
    );
  }

  updateStatus(
    ticketId: string,
    status: SupportTicketStatus
  ): Promise<SupportTicketModel> {
    const url = `${this.env.api}support-tickets/${ticketId}`;
    return firstValueFrom(
      this.http.patch<SupportTicketModel>(url, { status })
    );
  }

  markRead(
    ticketId: string,
    reporterLocale?: SupportTicketReporterLocale
  ): Promise<void> {
    const url = `${this.env.api}support-tickets/${ticketId}/mark-read`;
    const body =
      reporterLocale != null ? { reporterLocale } : ({} as Record<string, unknown>);
    return firstValueFrom(this.http.post<{ ok: boolean }>(url, body)).then(
      () => undefined
    );
  }
}
